import React, { useReducer } from 'react';

import LoginContext from './LoginContext'
import LoginReducer from './LoginReducer'

import { LOGIN_PORTAL, LOGOUT, LOADING, ERROR } from "../../types";

import Auth from '../../http_services/auth/'

const LoginState = (props) => {

    const initialState = {
        loading: false,
        error: null,
        access: null,
        role: [],
        jwt: null
    }

    const [state, dispatch] = useReducer(LoginReducer, initialState);

    const login = async(data) => {
      try{
        if(localStorage.getItem('access')){ localStorage.removeItem('access');}
        localStorage.setItem('access', `${data.tokenObj.token_type} ${data.tokenObj.access_token}`);
          loading()
          const respToken = await Auth();
          localStorage.setItem('token', respToken.data.jwt)
          dispatch({
              type: LOGIN_PORTAL,
              payload: respToken.data.jwt
            });
          loading()
      }catch(err){        
        let message = ''
        if (!err.response) {
          message = 'El servicio esta en matención, y no es posible conectarse.'
        } else {
          if(err.response.status === 403){           
            message = 'Usuaio no registrado en el sistema, favor contactarse con el administrador.'
          }else{
            message = 'Acceso denegado'
          }
        }
        dispatch({
          type: ERROR,
          payload: message
        });
      }
    }

    const logout = () => {
        dispatch({
            type: LOGOUT
          });
    }

    const errorEvent = (data) => {
        dispatch({
          type: ERROR,
          payload: 'Error con la autenticación desde Gmail'
        });
    }

    const loading = () => {
        dispatch({
          type: LOADING
        });
    }

    const isAdmin = () => {      
      if(state.role.filter(rol => rol.authority === "ROLE_ADMIN").length >= 1){ return true}
      else{ return false;} 
    }

    return ( 
        <LoginContext.Provider
            value={{
                loading: state.loading,
                access: state.access,
                error: state.error,
                token: state.jwt,
                isAdmin: isAdmin,
                errorEvent: errorEvent,
                logout: logout,
                login: login
            }}
        >
            {props.children}
        </LoginContext.Provider>
     );
}
 
export default LoginState;